import Cream from './Cream';

module.exports = {
  Cream,
};
